module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "car.56b20a5e.png";